export default {"src":"/_next/static/media/we-are-kd-circular.4f58b25d.svg","height":145,"width":145,"blurWidth":0,"blurHeight":0};